var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmergency(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 72,
    viewBox: "0 0 80 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.4755 14.0107H13.2584V71.1274H66.4755V14.0107Z",
    fill: "url(#paint0_linear_33_0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0382 14.0107C13.1024 14.0107 13.1666 14.0383 13.2584 14.0658C13.2584 33.068 13.2584 52.0701 13.2584 71.0998C9.13864 71.421 5.66118 70.3841 2.89939 67.7233C0.945041 65.8332 -2.18721e-05 63.6127 -2.18721e-05 61.0987C-2.18721e-05 52.1986 -2.18721e-05 43.3077 -2.18721e-05 34.4076C-2.18721e-05 31.0127 -0.00919724 27.6178 -0.00919724 24.2229C-0.00919724 20.1215 2.20207 17.1395 6.26675 15.1209C8.35873 14.0933 10.6801 13.9373 13.0382 14.0107Z",
    fill: "url(#paint1_linear_33_0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1809 14.0016C59.5573 14.0016 59.7958 14.0016 62.1631 14.0016C62.1631 33.068 62.1631 52.0701 62.1631 71.109C46.0053 71.109 33.7837 71.109 17.5708 71.109C17.5708 52.0793 17.5708 33.0771 17.5708 14.0199C19.9381 14.0199 20.4519 14.0199 22.865 14.0199C22.865 13.7813 22.865 13.5978 22.865 13.4235C22.865 11.3774 22.8742 9.32212 22.8558 7.27601C22.8375 5.84466 23.2228 4.59681 24.3422 3.62422C25.1313 2.94524 26.0397 2.59658 27.0673 2.59658C30.2512 2.5874 33.4259 2.5874 36.6097 2.5874C41.9589 2.5874 47.3174 2.59658 52.6666 2.5874C54.0704 2.5874 55.2357 3.04617 56.1532 4.11051C56.8873 4.96382 57.1625 5.96394 57.1625 7.08333C57.1533 9.23954 57.1625 11.3958 57.1625 13.552C57.1533 13.6712 57.1625 13.8089 57.1809 14.0016ZM28.6088 14.0016C28.829 14.0016 28.9942 14.0016 29.1593 14.0016C31.6917 14.0016 34.2333 14.0016 36.7657 14.0016C41.5002 14.0016 46.2438 14.0016 50.9783 14.0107C51.3545 14.0107 51.4371 13.8914 51.4371 13.5336C51.4187 11.9279 51.4371 10.3222 51.4371 8.71654C51.4371 8.58809 51.4187 8.45963 51.4004 8.322C43.7848 8.322 36.2152 8.322 28.6088 8.322C28.6088 10.2121 28.6088 12.0656 28.6088 14.0016Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33_0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 2,
    width: 46,
    height: 70
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1808 14.0016C59.5573 14.0016 59.7958 14.0016 62.1631 14.0016C62.1631 33.068 62.1631 52.0701 62.1631 71.109C46.0053 71.109 33.7837 71.109 17.5708 71.109C17.5708 52.0793 17.5708 33.0771 17.5708 14.0199C19.938 14.0199 20.4519 14.0199 22.865 14.0199C22.865 13.7813 22.865 13.5978 22.865 13.4235C22.865 11.3774 22.8742 9.32212 22.8558 7.27601C22.8375 5.84466 23.2228 4.59681 24.3422 3.62422C25.1313 2.94524 26.0397 2.59658 27.0673 2.59658C30.2512 2.5874 33.4258 2.5874 36.6097 2.5874C41.9589 2.5874 47.3173 2.59658 52.6666 2.5874C54.0704 2.5874 55.2357 3.04617 56.1532 4.11051C56.8872 4.96382 57.1625 5.96394 57.1625 7.08333C57.1533 9.23954 57.1625 11.3958 57.1625 13.552C57.1533 13.6712 57.1625 13.8089 57.1808 14.0016ZM28.6088 14.0016C28.829 14.0016 28.9941 14.0016 29.1593 14.0016C31.6917 14.0016 34.2333 14.0016 36.7657 14.0016C41.5002 14.0016 46.2438 14.0016 50.9783 14.0107C51.3545 14.0107 51.4371 13.8914 51.4371 13.5336C51.4187 11.9279 51.4371 10.3222 51.4371 8.71654C51.4371 8.58809 51.4187 8.45963 51.4004 8.322C43.7848 8.322 36.2151 8.322 28.6088 8.322C28.6088 10.2121 28.6088 12.0656 28.6088 14.0016Z",
    fill: "#F7F9FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.096 0H21V14.02H58.096V0Z",
    fill: "url(#paint2_linear_33_0)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24.0762C80 20.2959 77.9356 17.4791 74.2654 15.433C72.0083 14.176 69.4483 13.9374 66.8242 13.9925C66.4205 14.0016 66.4755 14.2127 66.4755 14.4329C66.4755 21.0391 66.4755 27.6362 66.4755 34.2425C66.4755 45.8493 66.4755 57.447 66.4663 69.0538C66.4663 69.7236 66.4663 70.3934 66.4663 71.1183C68.1179 71.1733 69.6869 71.1825 71.2284 70.8155C76.44 69.586 79.9908 65.7048 79.9908 61.1263C80.0092 48.7854 80 36.4262 80 24.0762Z",
    fill: "url(#paint3_linear_33_0)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2161 46.7852C44.2161 47.9688 44.2161 49.0882 44.2161 50.2168C44.2161 51.4921 44.2161 52.7675 44.2161 54.0337C44.2161 54.7953 43.8307 55.199 43.0783 55.199C41.0047 55.2082 38.9311 55.2082 36.8574 55.199C36.1693 55.199 35.7839 54.7677 35.7839 54.0429C35.7839 51.7674 35.7839 49.4919 35.7839 47.2164C35.7839 47.088 35.7839 46.9503 35.7839 46.7852C35.6096 46.7852 35.4811 46.7852 35.3435 46.7852C33.1047 46.7852 30.8567 46.7852 28.618 46.7852C27.7279 46.7852 27.3609 46.4273 27.3609 45.5373C27.3609 43.5646 27.3609 41.5919 27.3609 39.6192C27.3609 38.72 27.7188 38.3622 28.6088 38.3622C30.8384 38.3622 33.068 38.3622 35.2976 38.3622C35.4444 38.3622 35.5821 38.3622 35.7747 38.3622C35.7747 38.2154 35.7747 38.0961 35.7747 37.9768C35.7747 35.7013 35.7747 33.4258 35.7747 31.1504C35.7747 30.3062 36.1509 29.9392 36.9951 29.9392C38.9678 29.9392 40.9405 29.9392 42.9132 29.9392C43.8399 29.9392 44.1977 30.2879 44.1977 31.2329C44.2069 33.4901 44.1977 35.738 44.1977 37.9952C44.1977 38.1053 44.1977 38.2154 44.1977 38.3714C44.3445 38.3714 44.473 38.3714 44.5923 38.3714C46.8678 38.3714 49.1432 38.3714 51.4187 38.3805C52.2537 38.3805 52.6115 38.7476 52.6115 39.5825C52.6115 41.5644 52.6115 43.5463 52.6115 45.5282C52.6115 46.4365 52.2629 46.7852 51.3729 46.7852C49.1065 46.7852 46.8402 46.7852 44.5831 46.7944C44.4913 46.7852 44.3812 46.7852 44.2161 46.7852Z",
    fill: "url(#paint4_linear_33_0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33_0",
    x1: 13.2597,
    y1: 42.5656,
    x2: 66.473,
    y2: 42.5656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#69DCFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33_0",
    x1: -0.0000218711,
    y1: 42.5746,
    x2: 13.2597,
    y2: 42.5746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_33_0",
    x1: 20.9962,
    y1: 7.00849,
    x2: 58.0944,
    y2: 7.00849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_33_0",
    x1: 66.4686,
    y1: 42.569,
    x2: 80.0007,
    y2: 42.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_33_0",
    x1: 27.3666,
    y1: 42.5783,
    x2: 52.6299,
    y2: 42.5783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CBCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#458DFC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 71.1549,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/emergency.ba14708c998d1c1102f470ba66d36de5.svg";
export { ForwardRef as ReactComponent };